(() => {
const form = document.getElementById('dc-coupon-form');
if (!form) return;
form.addEventListener('submit', async event => {
 event.preventDefault();
 const button = form.querySelector('button');
 const status = document.getElementById('dc-coupon-status');
 const code = document.getElementById('dc-coupon').value.trim();
 if (!code) return;
 button.disabled = true;
 status.textContent = 'Verificando cupom…';
 try {
  const response = await fetch((window.Shopify?.routes?.root ?? '/') + 'cart/update.js', {
   method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({discount: code})
  });
  const cart = await response.json();
  if (!response.ok) throw new Error();
  const valid = cart.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
  const applied = cart.cart_level_discount_applications?.some(item => item.title.toLowerCase() === code.toLowerCase()) || cart.items?.some(item => item.discounts?.some(discount => discount.title?.toLowerCase() === code.toLowerCase()));
  if (valid || applied) location.reload();
  else status.textContent = 'Cupom inválido ou não aplicável aos produtos deste carrinho.';
 } catch (_) { status.textContent = 'Não foi possível verificar o cupom. Tente novamente.'; }
 finally { button.disabled = false; }
});
})();